import { useFormikContext } from 'formik';
import { ReactNode } from 'react';
import styled from 'styled-components';

import { Text } from '../../../cdl/Text/Text';
import { OfferModel } from '../../../offer/model/OfferModel';
import {
    calculateItemTotal,
    calculatePpl,
    calculateTotal,
    calculateVolume,
    calculateVolumeWithPrices,
} from '../../helpers/calculate.utilities';
import { formatNumber } from '../../helpers/formatNumber.helper';
import { formatPrice } from '../../helpers/formatPrice.helper';
import { formatTotalPrice } from '../../helpers/formatTotal.helper';
import { translate } from '../../helpers/translate.helper';
import { Characters } from '../../helpers/unicode.helper';
import { Box } from '../../ui/Box';
import { theme } from '../../ui/theme';
import { TotalRowTd } from '../components/TotalRowTd';
import { useProductTableConfig } from '../hooks/useProductTableConfig';

interface TotalValueWrapperProps {
    children: ReactNode;
}

const TotalValueWrapper = ({ children }: TotalValueWrapperProps) => {
    return (
        <Box display="flex" justifyContent="flex-end">
            <Text variant="small">{children}</Text>
        </Box>
    );
};

const CustomTr = styled.tr`
    background-color: ${theme.colors.background.subtle};

    border-bottom: 1px solid ${theme.colors.border.subtle} !important;
    border-right: 1px solid ${theme.colors.border.subtle} !important;
    border-left: 1px solid ${theme.colors.border.subtle} !important;
`;

export const TotalRow = () => {
    const { values } = useFormikContext<OfferModel>();
    const { editPrices } = useProductTableConfig();

    const totalVolume = calculateVolume(values.items);
    const allTotal = calculateTotal(values.items, values.surcharges, values.samplekits);

    const pricePerLiter = calculatePpl(calculateItemTotal(values.items), calculateVolumeWithPrices(values.items));
    return (
        <CustomTr>
            <TotalRowTd colSpan={5}>
                <Text variant="small">{translate('global.total')}</Text>
            </TotalRowTd>

            <TotalRowTd>
                <TotalValueWrapper>{formatNumber({ number: totalVolume })}</TotalValueWrapper>
            </TotalRowTd>

            <TotalRowTd />

            <TotalRowTd>
                <Box display="flex" justifyContent={editPrices ? 'flex-start' : 'flex-end'}>
                    <Text variant="small">
                        {pricePerLiter.value
                            ? formatPrice({
                                  value: pricePerLiter.value,
                                  currency: pricePerLiter.currency || 'USD',
                              })
                            : Characters.EN_DASH}
                    </Text>
                </Box>
            </TotalRowTd>

            <TotalRowTd>
                <TotalValueWrapper>
                    {allTotal.value
                        ? formatTotalPrice({
                              value: allTotal.value,
                              currency: allTotal.currency || 'USD',
                          })
                        : Characters.EN_DASH}
                </TotalValueWrapper>
            </TotalRowTd>

            <TotalRowTd>{null}</TotalRowTd>
        </CustomTr>
    );
};
